var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    ref: "rootEl",
    attrs: { value: _vm.value, items: _vm.suggestions },
    on: {
      input: function ($event) {
        return _vm.onInput($event)
      },
      "item-click": function ($event) {
        return _vm.onSelect($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (p) {
          return [
            _vm._v(
              " " +
                _vm._s(p.item.name ? p.item.name : p.item.value) +
                " " +
                _vm._s(p.item.name ? "(" + p.item.value + ")" : "") +
                " "
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }